import {makeAutoObservable} from 'mobx';
import {host} from '@/utils/hostConf';
import * as http from '@/utils/baseRequest';

class Store {
    list = [];
    docInfo = {
        name: 111
    };

  constructor() {
    makeAutoObservable(this);
  }

  // 科室查询 | 查询分院的科室
  fetchDoctorList(data) {
    let postData = {
      page_no: '1',
      page_size: '10',
      ...data,
    };
    return http.post({
      url: host.cplus + 'cgi-bin/search/doctorrecommendv2',
      data: postData,
    });
  }

  // 查询医生title
  fetchDocTitl(data) {
    return http.post({
      url: host.cplus + 'cgi-bin/search/getfiltertitles',
      data: data,
    });
  }

  // 查询价格
  fetchDocPrices(data) {
    return http.get({
      url: host.cplus + 'cgi-bin/search/getfilterprices',
      data,
    });
  }
}

export default new Store();
